import {NgModule} from '@angular/core';
import {AutocompleteModule} from '../../autocomplete';
import {L10nModule} from '../../translate';
import {DeliverableAutocompleteListComponent} from './deliverable-autocomplete-list.component';
import {DeliverableAutocompleteDirective} from './deliverable-autocomplete.directive';
import {DeliverableAutocompleteService} from './deliverable-autocomplete.service';

@NgModule({
    imports: [
        L10nModule,
        AutocompleteModule
    ],
    declarations: [
        DeliverableAutocompleteDirective,
        DeliverableAutocompleteListComponent
    ],
    exports: [
        DeliverableAutocompleteDirective
    ],
    providers: [
        DeliverableAutocompleteService
    ]
})
export class DeliverableAutocompleteModule {}
